<template>
  <div class="layout__position-left layout__width-100">

    <el-form
      :model="searchParams"
      status-icon
      :rules="{}"
      ref="searchParams"
    >

      <div class="layout__padding-clear text__align-center layout__width-100">
        <div class="layout__search-field__insights-250px">
          <p class="layout__margin__bottom-10 text__align-left">Territory</p>
          <el-form-item prop="territory">
            <el-select
              v-model="searchParams.territory"
              placeholder="Select"
              @change="handleTerritorySelect"
            >
              <el-option
                v-for="item in territories"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <el-button
      class="button-red button__base button__insights"
      @click="getSales('searchParams')"
    >
      Refresh Data
    </el-button>

    <el-button
      class="button-teal button__base button__insights"
      :disabled="this.sales.length === 0"
      @click="csv"
    >
      Download CSV
    </el-button>

  </div>

</template>

<script>
import Axios from 'axios';
import moment from 'moment';
import download from 'downloadjs';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import ClientsListSalesTerritory from '../../enums/ClientsListSalesTerritory';

export default {
  name: 'ClientsListSalesTerritorySearch',
  mixins: [axios, csvDownloadHelper, dataFormatter],
  props: {
    searchParams: {},
    territories: {
      type: Array,
      required: true,
    },
    shouldUpdateTotal: {
      type: Boolean,
      required: true,
    },
    sales: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    currentPage() {
      this.getSales('searchParams');
    },

    total() {
      this.getSales('searchParams');
    },
  },

  data() {
    return {
      isLoading: false,
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_client_list_fo_sales_category.csv',
      invoicedValue: 'A',
      clientsListSalesTerritory: ClientsListSalesTerritory,
      previousTerritory: null,
      dateRange: [],
      downloadUrl: '',
      myChart: Object,
      pickerOptions: {},
    };
  },

  computed: {
    currentPage() {
      return this.searchParams.currentPage;
    },

    total() {
      return this.searchParams.total;
    },
  },

  created() {
    console.log('CREATED');
    const date = new Date();
    date.setDate(date.getDate() - 7);
    console.log('created date');

    console.log(this.searchParams);
  },

  mounted() {
    console.log('MOUNTED');
    this.getSales('searchParams');
  },

  destroyed() {
    console.log('DESTROYED');

    console.log(this.searchParams);
  },

  beforeUpdate() {
    window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
  },

  methods: {
    swapInvoiced: function (component) {
      console.log('dropdownValue=' + this.invoicedValue);
      // this.currentComponent = component;
    },

    getSales(searchParams) {
      if (this.shouldUpdateTotal) {
        this.$emit('update-total');

        return;
      }

      this.isLoading = true;

      this.$refs[searchParams].validate((valid) => {
        if (valid) {

          console.log('before');
          console.log(this.searchParams);

          let searchTerms = Object.assign({}, this.searchParams);
          console.log('searchTerms');
          console.log(searchTerms);

          console.log('after search is copied');
          console.log(this.searchParams);

          console.log('after search is copied - new object');
          console.log(searchTerms);

          if (this.previousTerritory !== this.searchParams.territory) {
            this.searchParams.currentPage = 1;
          }

          this.previousTerritory = this.searchParams.territory;

          const endpoint = `${this.serviceRouteUrl}/api/v1/DynamicQuery/GetClientListForTerritory?territoryId=${this.searchParams.territory}&getCount=0&cnt=${this.searchParams.pagination}&start=${this.searchParams.pagination * (this.searchParams.currentPage - 1)}`;

          console.log(endpoint);

          this.$parent.loading = true;

          Axios.get(endpoint, this.returnHeaderUsingToken())
            .then(response => {
              let clientsListSalesTerritory = response.data;

              clientsListSalesTerritory = clientsListSalesTerritory.map((clientListSalesTerritory) => {
                clientListSalesTerritory['lastOrderDate'] = clientListSalesTerritory['lastOrderDate']
                  ? moment(clientListSalesTerritory['lastOrderDate']).format('DD/MM/YYYY')
                  : '';

                return {
                  ...clientListSalesTerritory,
                };
              });

              this.$parent.sales = clientsListSalesTerritory;

              this.$nextTick(() => { // Loading should be closed asynchronously
                this.$parent.loading = false;
              });

              this.isLoading = false;
            })
            .catch(error => {
              if (error.response) {
                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
              }

              this.$nextTick(() => { // Loading should be closed asynchronously
                this.$parent.loading = false;
              });

              this.$parent.sales = [];

              this.isLoading = false;
            });
        } else {
          this.isLoading = false;

          return false;
        }
      });
    },

    csv() {
      const fields = this.clientsListSalesTerritory.createLabelValueList();

      this.downloadCsv(this.exportDate, fields, this.sales);
    },

    handleTerritorySelect() {
      this.$emit('territory-updated', true);
    },
  }
};
</script>